"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Card = require("./Card");

var _Card2 = _interopRequireDefault(_Card);

var _Icon = require("../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _Tooltip = require("../Tooltip");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Widget = function (_React$Component) {
  _inherits(Widget, _React$Component);

  function Widget() {
    _classCallCheck(this, Widget);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Widget.prototype.handleDelete = function handleDelete(e) {
    e.preventDefault();
    this.props.handleDelete(e);
  };

  Widget.prototype.handleAdd = function handleAdd(e) {
    e.preventDefault();
    this.props.handleAdd(e);
  };

  Widget.prototype.handleEdit = function handleEdit(e) {
    e.preventDefault();
    this.props.handleEdit(e);
  };

  Widget.prototype.render = function render() {
    var _props = this.props;
    var _props$prefixCls = _props.prefixCls;
    var prefixCls = _props$prefixCls === undefined ? "ant-widget" : _props$prefixCls;
    var _props$addTip = _props.addTip;
    var addTip = _props$addTip === undefined ? "添加" : _props$addTip;


    var extra = _react2["default"].createElement(
      "div",
      { className: prefixCls + "-extra" },
      _react2["default"].createElement(
        _Tooltip2["default"],
        { title: "删除" },
        _react2["default"].createElement(
          "a",
          { href: "#" },
          _react2["default"].createElement(_Icon2["default"], { type: "delete" })
        )
      ),
      _react2["default"].createElement(
        _Tooltip2["default"],
        { title: addTip },
        _react2["default"].createElement(
          "a",
          { href: "#" },
          _react2["default"].createElement(_Icon2["default"], { type: "plus" })
        )
      ),
      _react2["default"].createElement(
        _Tooltip2["default"],
        { title: "编辑" },
        _react2["default"].createElement(
          "a",
          { href: "#" },
          _react2["default"].createElement(_Icon2["default"], { type: "edit" })
        )
      )
    );

    return _react2["default"].createElement(_Card2["default"], _extends({ extra: extra }, this.props));
  };

  return Widget;
}(_react2["default"].Component);

exports["default"] = Widget;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/card/Widget.jsx
 ** module id = 171
 ** module chunks = 0
 **/